import { PartnerLogo } from 'components/PartnerLogo/PartnerLogo';

type PartnerCellProps = {
  logoUrl?: string | null;
  name: string;
};

export const PartnerCell = ({ logoUrl, name }: PartnerCellProps) => (
  <div className="flex items-center gap-3">
    <PartnerLogo imageUrl={logoUrl} name={name} size="small" />
    <span className="truncate text-sm font-medium text-gray-900">{name}</span>
  </div>
);
